// Bloque "Gracias a nuestros increíbles facturers..." del registro.
// Port del helper qualitySeal de keycloak.coffee. La línea con
// "ponte en contacto" abre el chat Intercom.

import { showIntercom } from "../trackers";
import { msg } from "../i18n";

export function QualitySeal() {
  // El bloque tiene HTML rico (un <b> y un <p> con un <a> para Intercom).
  // Pre-resolvemos el HTML completo en messages y atamos el listener
  // de Intercom delegando en el click del contenedor (el <a> lleva
  // data-action="intercom" en la message para identificarlo).
  const onClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    const t = e.target as HTMLElement;
    if (t.closest("a[data-action='intercom']")) {
      e.preventDefault();
      showIntercom();
    }
  };

  return (
    <div className="quality" onClick={onClick}>
      <div
        className="text-quality"
        dangerouslySetInnerHTML={{ __html: msg("qualitySealHtml") }}
      />
    </div>
  );
}
